<template>
 <div class="wrap talk  re-style">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt">
						<h2>PASS 본인인증</h2>
					</section>
          <section>
            <div class="box row row_c row_jsc">
              <p v-if="!isProc">인증 및 접수 처리가 완료되었습니다!</p>
              <p v-if="isProc">접수신청이 실패했어요</p>
						</div>
          </section>
				</article>
			</main>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'


export default {
  name: 'CrtfPassSuc4',
  components: {

   },
  data: () => ({
    AppConfig: AppConfig,
    isProc: false,
  }),
  computed: {

  },
  mounted() {
    this.isProc = !!this.$route.query.err_msg
    if(this.$route.query.err_msg)
      switch(this.$route.query.err_msg){
        case "01":
          Vue.Alert.alert("신청 가능한 보상 내역이 없습니다.\n(보상신청 미확인, 반납기한 초과, 보상취소, 보상접수 완료).\n고객센터에 문의 부탁드립니다.");
          break;
        case "02":
          Vue.Alert.alert("신청주신 모델은 보상대상이 아닙니다.\n고객센터에 문의 부탁드립니다.");
          break;
        case "03":
          Vue.Alert.alert("접수가 정상 처리 되지 않았습니다.");
          break;

      }
  },
  methods: {

    async certPassSuc () {

      const vm = this;
      const params = {
        atmId       : 'bos_test',
        prncCrtfNum : window.btoa('XADLAo0zndl4moDY1YzGmA=='),
        encData     : this.$route.query.EncodeData,
        param_r2    : this.$route.query.param_r2,
      }

      console.log('params ==> {}', params)
      const rtn = await Vue.httpClient
        .get('/api/purchase/crtf/public/crtfPassSuc/' + this.$route.query.passType, {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result)
              console.log(res.data.result)

          } else {
            Vue.Alert.alert("통신 오류 입니다.")
          }

        })

    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/crtfpass/CrtfPassSuc4.vue